import { useMemo } from 'react';
import useSyncURLParamsFromState from '../../../utils/hooks/useSyncURLParamsFromState';
import { BapUrlParam, INCLUDE_FEES_URL_PARAM, INCLUDE_TAXES_URL_PARAM, LOYALTY_OFFER_KEY, OFFER_KEYS_URL_PARAM, } from '../../../utils/constants';
import { CalculatorUrlKeys, primaryCalculatorId, selectPaymentOptions, selectPrimaryCalculatorIncentiveOfferIdsParam, selectPrimaryCalculatorLoyaltyOfferKey, } from '../../../core/reducers/financialCalculators';
import { selectCurrentVehicle } from '../../../core/reducers/currentVehicle';
import { useAppSelector } from '../../../core/utils';
export default function useSyncBAPStateToURL() {
    const loyaltyOfferKey = useAppSelector(selectPrimaryCalculatorLoyaltyOfferKey);
    const offerKeys = useAppSelector(selectPrimaryCalculatorIncentiveOfferIdsParam);
    const { accessoryKeys, protectionKeys, protectionAddOnKeys } = useAppSelector(selectCurrentVehicle);
    const { overriddenIsSellingProvince, includeFees, leaseAnnualKmAllowance, leaseAdditionalAnnualKm, downPaymentAmount, tradeInValueAmount, tradeInOwingAmount, } = useAppSelector(state => selectPaymentOptions(state, primaryCalculatorId));
    const data = useMemo(() => [
        {
            state: accessoryKeys === null || accessoryKeys === void 0 ? void 0 : accessoryKeys.join(','),
            queryParam: BapUrlParam.ACCESSORY_KEYS,
        },
        {
            state: protectionKeys === null || protectionKeys === void 0 ? void 0 : protectionKeys.join(','),
            queryParam: BapUrlParam.PROTECTION_KEYS,
        },
        {
            state: protectionAddOnKeys === null || protectionAddOnKeys === void 0 ? void 0 : protectionAddOnKeys.join(','),
            queryParam: BapUrlParam.PROTECTION_ADD_ON_KEYS,
        },
        {
            state: loyaltyOfferKey,
            queryParam: LOYALTY_OFFER_KEY,
        },
        {
            state: offerKeys,
            queryParam: OFFER_KEYS_URL_PARAM,
            updateCondition: () => true,
        },
        {
            state: includeFees ? 'true' : 'false',
            queryParam: INCLUDE_TAXES_URL_PARAM,
        },
        {
            state: overriddenIsSellingProvince ? 'true' : 'false',
            queryParam: INCLUDE_FEES_URL_PARAM,
        },
        {
            state: `${leaseAdditionalAnnualKm}`,
            queryParam: 'leaseAdditionalAnnualKm',
        },
        {
            state: `${leaseAnnualKmAllowance}`,
            queryParam: 'leaseAnnualKmAllowance',
        },
        {
            state: `${downPaymentAmount}`,
            queryParam: CalculatorUrlKeys.downPayment,
        },
        {
            state: `${tradeInValueAmount}`,
            queryParam: CalculatorUrlKeys.tradeInValue,
        },
        {
            state: `${tradeInOwingAmount}`,
            queryParam: CalculatorUrlKeys.tradeInOwing,
        },
    ], [
        overriddenIsSellingProvince,
        includeFees,
        leaseAnnualKmAllowance,
        leaseAdditionalAnnualKm,
        downPaymentAmount,
        tradeInValueAmount,
        tradeInOwingAmount,
        accessoryKeys,
        protectionKeys,
        protectionAddOnKeys,
        loyaltyOfferKey,
        offerKeys,
    ]);
    useSyncURLParamsFromState(data);
}
